module.exports = __webpack_public_path__ + "img/chevron-green.f7ff227f.svg";